export enum GallerySearchMode {
  Query,
  Path
}
